import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { Input } from "../../../../_metronic/_partials/controls";
import { SelectObjectsField } from "../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField";
import { SelectStatus } from '../../customComponents/SelectStatus';


export const initObject = {
  id: undefined,
  rowIndex: undefined,
  title: "",
  auditPeriodId: 0,
  auditPeriodTitle: "",
  auditPlaceId: 0,
  auditPlaceTitle: "",
  auditFormTypeId: 0,
  auditFormTypeTitle: "",
  questionId: 0,
  questionTitle: "",
  answerType: 1,

  buildingId: null,
  buildingTitle: "",
  floorId: null,
  floorTitle: "",
  roomId: null,
  roomTitle: "",
  seatId: null,
  seatTitle: "",

  answerOfQuestionId: null,
  answerOfQuestionTitle: "",
  editorId: null,
  editorFullName: "",
  creatorId: null,
  creatorFullName: "",
  createAt: "",
  editedAt: "",

  answerCount: "",
  enteredAnswer: "",
  status: ""
};

export const rowFormatter = (row, idx) => {
  if (row.id && row.id !== 0) return "table-primary";
  else if (!row.rowIndex) return "table-warning";
  else return "";
  // return row.trafficTypeCode && row.trafficTypeCode > 0 ?  : '';
};

export const editRowFormatter = (row, idx) => {
  // if (row.status === null || row.status === "NotCompleted") return "holiday-row-class";
  // else return "edited-row-class";
  // // return row.trafficTypeCode && row.trafficTypeCode > 0 ?  : '';
  if (row.status !== null && row.status !== "NotCompleted") return "edited-row-class";
  return "";
};

export const buildingColumns = [
  {
    dataField: "rowIndex",
    text: "ردیف",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "buildingTitle",
    text: "عنوان",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "questionTitle",
    text: "پرسش",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "answerOfQuestionTitle",
    text: "پاسخ ",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "enteredAnswer",
    text: "پاسخ ثبت شده",
    sort: false,
    sortCaret: sortCaret,
  },
];

export const placColumns = [
  {
    dataField: "rowIndex",
    text: "ردیف",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "auditPlaceTitle",
    text: "عنوان",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "questionTitle",
    text: "پرسش",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "answerOfQuestionTitle",
    text: "پاسخ ",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "enteredAnswer",
    text: "پاسخ ثبت شده",
    sort: false,
    sortCaret: sortCaret,
  },
];

export const columns = [
  {
    dataField: "any",
    text: "#",
    formatter: columnFormatters.IndexColumnFormatter,
    headerAttrs: {
      hidden: true,
    },
  },
  {
    dataField: "title",
    // text: "عنوان",
    sort: false,
    sortCaret: sortCaret,
    headerAttrs: {
      hidden: true,
    },
  },
  {
    dataField: "provinceTitle",
    text: "استان",
    sort: false,
    sortCaret: sortCaret,
    headerAttrs: {
      hidden: true,
    },
  },
  {
    dataField: "code",
    text: "کد ",
    sort: false,
    sortCaret: sortCaret,
    headerAttrs: {
      hidden: true,
    },
  },
  // {
  //   dataField: "answerOfQuestionTitle",
  //   text: "پاسخ ",
  //   sort: false,
  //   sortCaret: sortCaret,
  // },
  // {
  //   dataField: "enteredAnswer",
  //   text: "پاسخ ثبت شده",
  //   sort: false,
  //   sortCaret: sortCaret,
  // },
];

export const detailColumns = [
  // {
  //   dataField: "questionTitle",
  //   text: "پرسش",
  //   sort: false,
  //   sortCaret: sortCaret,
  //   headerAttrs: {
  //     hidden: true,
  //   },
  // },
  {
    dataField: "answerOfQuestionTitle",
    text: "متن پاسخ",
    sort: false,
    sortCaret: sortCaret,
    headerAttrs: {
      hidden: true,
    },
  },
  {
    dataField: "enteredAnswer",
    text: "پاسخ",
    sort: false,
    sortCaret: sortCaret,
    headerAttrs: {
      hidden: true,
    },
  },
];

export const provienceColumns = [
  {
    dataField: "rowIndex",
    text: "ردیف",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "provinceTitle",
    text: "عنوان",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "questionTitle",
    text: "پرسش",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "answerOfQuestionTitle",
    text: "پاسخ ",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "enteredAnswer",
    text: "پاسخ ثبت شده",
    sort: false,
    sortCaret: sortCaret,
  },
];

export const countryColumns = [
  {
    dataField: "rowIndex",
    text: "ردیف",
    sort: false,
    sortCaret: sortCaret,
  },
  // {
  //   dataField: "provinceTitle",
  //   text: "عنوان",
  //   sort: false,
  //   sortCaret: sortCaret,
  // },
  {
    dataField: "questionTitle",
    text: "پرسش",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "answerOfQuestionTitle",
    text: "پاسخ ",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "enteredAnswer",
    text: "پاسخ ثبت شده",
    sort: false,
    sortCaret: sortCaret,
  },
];

export const townColumns = [
  {
    dataField: "rowIndex",
    text: "ردیف",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "townTitle",
    text: "عنوان",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "questionTitle",
    text: "پرسش",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "answerOfQuestionTitle",
    text: "پاسخ ",
    sort: false,
    sortCaret: sortCaret,
  },
  {
    dataField: "enteredAnswer",
    text: "پاسخ ثبت شده",
    sort: false,
    sortCaret: sortCaret,
  },
];



export const setParentData = (entities) => {
  // const parentEntities = []
  // entities.forEach(element => {
  //   if (!parentEntities.find(q => q.Id === element.Id)) {


  //     parentEntities.push({ ...element, details })
  //   }
  // });
  return entities
}

export const setDetailData = (id, entities) => {
  const detailEntities = [...entities.find(q => q.id === id).answers]
  return detailEntities
}


export const formFields = [
  {
    row: 1,
    list: [
      {
        name: "enteredAnswer",
        type: "text",
        component: Input,
        auditPlaceholder: "پاسخ",
        label: "پاسخ",
        rowIdx: 1,
        class: "col-lg-6"
      },
    ]
  },

];

export const otherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];

export const filterFields = [
  {
    name: "auditPeriodId",
    lable: "دوره ارزیابی",
    type: "parentComponent",
    list: [],
    rowIdx: 1,
    component: (props) => (
      <SelectObjectsField
        api="api/AuditPeriod"
        reduxState="auditPeriods"
        sname="auditPeriodId"
        label=" "
        {...props}
      />
    ),
    relField: ["auditFormTypeId", "questionId", "answerOfQuestionId"],
    relValues: { auditFormTypeId: 0, questionId: 0, answerOfQuestionId: 0 },
  },
  {
    name: "auditFormTypeId",
    lable: "پرسشنامه",
    type: "parentComponent",
    list: [],
    rowIdx: 2,
    component: (props) => (
      <SelectObjectsField api="api/auditFormType"
        reduxState="auditFormTypes"
        sname="auditFormTypeId"
        keyFieldName="formTypeId"
        label=" "
        {...props} />
    ),
    relField: ["questionId", "answerOfQuestionId"],
    relValues: { questionId: 0, answerOfQuestionId: 0 },
  },
  {
    name: "categoryId",
    lable: "کاربری پرسش",
    type: "parentComponent",
    list: [],
    rowIdx: 3,
    component: (props) => (
      <SelectObjectsField
        api="api/category"
        reduxState="roomCategories"
        sname="categoryId"
        // keyFieldName="categoryId"
        // valueFieldNames={["categoryTitle"]}
        label=" "
        {...props} />
    ),
    relField: ["questionId"],
    relValues: { questionId: 0 },
  },
  {
    name: "questionId",
    lable: "پرسش",
    type: "parentComponent",
    list: [],
    rowIdx: 3,
    component: (props) => (
      <SelectObjectsField
        api="api/FormQuestion"
        functionName="GetByCategoryId"
        reduxState="filterQuestions"
        sname="questionId"
        keyFieldName="questionId"
        valueFieldNames={["questionTitle"]}
        label=" "
        {...props} />
    ),
    relField: ["answerOfQuestionId"],
    relValues: { answerOfQuestionId: 0 },
  },
  {
    name: "answerOfQuestionId",
    lable: "پاسخ",
    type: "component",
    list: [],
    rowIdx: 6,
    component: (props) => (
      <SelectObjectsField api="api/AnswerOfQuestion"
        reduxState="filterAnswers"
        sname="answerOfQuestionId"
        valueFieldNames={["answerTitle"]}
        label=" "
        {...props} />
    ),
    relField: [],
    relValues: {},
  },

];

export const provienceFilterFields = [
  // {
  //   name: "provinceId",
  //   lable: "استان",
  //   type: "component",
  //   list: [],
  //   rowIdx: 6,
  //   component: (props) => (
  //     <SelectObjectsField api="api/Province"
  //       reduxState="provinces"
  //       sname="provinceId"
  //       label=" "
  //       {...props} />
  //   ),
  //   relField: [],
  //   relValues: {},
  // },
  {
    name: "auditPeriodId",
    lable: "دوره ارزیابی",
    type: "parentComponent",
    list: [],
    rowIdx: 1,
    component: (props) => (
      <SelectObjectsField
        api="api/AuditPeriod"
        reduxState="auditPeriods"
        sname="auditPeriodId"
        label=" "
        {...props}
      />
    ),
    relField: ["auditFormTypeId", "questionId", "answerOfQuestionId"],
    relValues: { auditFormTypeId: 0, questionId: 0, answerOfQuestionId: 0 },
  },
  {
    name: "auditFormTypeId",
    lable: "پرسشنامه",
    type: "parentComponent",
    list: [],
    rowIdx: 2,
    component: (props) => (
      <SelectObjectsField api="api/auditFormType"
        reduxState="auditFormTypes"
        sname="auditFormTypeId"
        keyFieldName="formTypeId"
        label=" "
        {...props} />
    ),
    relField: ["questionId", "answerOfQuestionId"],
    relValues: { questionId: 0, answerOfQuestionId: 0 },
  },
  {
    name: "categoryId",
    lable: "کاربری پرسش",
    type: "parentComponent",
    list: [],
    rowIdx: 3,
    component: (props) => (
      <SelectObjectsField
        api="api/category"
        reduxState="roomCategories"
        sname="categoryId"
        // keyFieldName="categoryId"
        // valueFieldNames={["categoryTitle"]}
        label=" "
        {...props} />
    ),
    relField: ["questionId"],
    relValues: { questionId: 0 },
  },
  {
    name: "questionId",
    lable: "پرسش",
    type: "parentComponent",
    list: [],
    rowIdx: 3,
    component: (props) => (
      <SelectObjectsField
        api="api/FormQuestion"
        functionName="GetByCategoryId"
        reduxState="filterQuestions"
        sname="questionId"
        keyFieldName="questionId"
        valueFieldNames={["questionTitle"]}
        label=" "
        {...props} />
    ),
    relField: ["answerOfQuestionId"],
    relValues: { answerOfQuestionId: 0 },
  },
  {
    name: "answerOfQuestionId",
    lable: "پاسخ",
    type: "component",
    list: [],
    rowIdx: 6,
    component: (props) => (
      <SelectObjectsField api="api/AnswerOfQuestion"
        reduxState="filterAnswers"
        sname="answerOfQuestionId"
        valueFieldNames={["answerTitle"]}
        label=" "
        {...props} />
    ),
    relField: [],
    relValues: {},
  },

];

export const placeFilterFields = [

  {
    name: "auditPeriodId",
    lable: "دوره ارزیابی",
    type: "parentComponent",
    list: [],
    rowIdx: 1,
    component: (props) => (
      <SelectObjectsField
        api="api/AuditPeriod"
        reduxState="auditPeriods"
        sname="auditPeriodId"
        label=" "
        {...props}
      />
    ),
    relField: ["auditPlaceId", "auditFormTypeId", "questionId", "answerOfQuestionId"],
    relValues: { auditPlaceId: 0, auditFormTypeId: 0, questionId: 0, answerOfQuestionId: 0 },
  },
  // {
  //   name: "auditPlaceId",
  //   lable: "پردیس / مرکز",
  //   type: "parentComponent",
  //   list: [],
  //   rowIdx: 3,
  //   component: (props) => (
  //     <SelectObjectsField api="api/auditPlace"
  //       reduxState="auditPlaces"
  //       sname="auditPlaceId"
  //       label=" "
  //       {...props} />
  //   ),
  //   relField: [],
  //   relValues: {},
  // },
  {
    name: "auditFormTypeId",
    lable: "پرسشنامه",
    type: "parentComponent",
    list: [],
    rowIdx: 2,
    component: (props) => (
      <SelectObjectsField api="api/auditFormType"
        reduxState="auditFormTypes"
        sname="auditFormTypeId"
        keyFieldName="formTypeId"
        label=" "
        {...props} />
    ),
    relField: ["questionId", "answerOfQuestionId"],
    relValues: { questionId: 0, answerOfQuestionId: 0 },
  },
  {
    name: "categoryId",
    lable: "کاربری پرسش",
    type: "parentComponent",
    list: [],
    rowIdx: 3,
    component: (props) => (
      <SelectObjectsField
        api="api/category"
        reduxState="roomCategories"
        sname="categoryId"
        // keyFieldName="categoryId"
        // valueFieldNames={["categoryTitle"]}
        label=" "
        {...props} />
    ),
    relField: ["questionId"],
    relValues: { questionId: 0 },
  },
  {
    name: "questionId",
    lable: "پرسش",
    type: "parentComponent",
    list: [],
    rowIdx: 3,
    component: (props) => (
      <SelectObjectsField
        api="api/FormQuestion"
        functionName="GetByCategoryId"
        reduxState="filterQuestions"
        sname="questionId"
        keyFieldName="questionId"
        valueFieldNames={["questionTitle"]}
        label=" "
        {...props} />
    ),
    relField: ["answerOfQuestionId"],
    relValues: { answerOfQuestionId: 0 },
  },
  {
    name: "answerOfQuestionId",
    lable: "پاسخ",
    type: "component",
    list: [],
    rowIdx: 6,
    component: (props) => (
      <SelectObjectsField api="api/AnswerOfQuestion"
        reduxState="filterAnswers"
        sname="answerOfQuestionId"
        valueFieldNames={["answerTitle"]}
        label=" "
        {...props} />
    ),
    relField: [],
    relValues: {},
  },

];

// export const filterInitialValues = {
//   auditPeriodId: 0,
//   auditPlaceId: 0,
//   buildingId: 0,
//   floorId: 0,
//   roomId: 0,
//   auditFormTypeId: 0,
// };

export const filterInitialValues = {
  filter: {
    provinceId: 0,
    auditPeriodId: 0,
    auditFormTypeId: 0,
    auditPlaceId: 0,
    questionId: 0,
    categoryId: 0,
    answerOfQuestionId: 0,

  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 100,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 1000,
};


export const prepareFilter = (queryParams, values) => {
  const { provinceId, auditPeriodId, auditFormTypeId, auditPlaceId, questionId, categoryId, answerOfQuestionId } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};

  // Filter by auditPeriodId
  // filter.provinceId = provinceId !== "" ? +provinceId : 0;
  // filter.auditPlaceId = auditPlaceId !== "" ? +auditPlaceId : 0;
  filter.auditPeriodId = auditPeriodId !== "" ? +auditPeriodId : 0;
  filter.auditFormTypeId = auditFormTypeId !== "" ? +auditFormTypeId : 0;
  filter.questionId = questionId !== "" ? +questionId : 0;
  filter.categoryId = categoryId !== "" ? +categoryId : 0;
  filter.answerOfQuestionId = answerOfQuestionId !== "" ? +answerOfQuestionId : 0;
  newQueryParams.filter = filter

  let whereClause = ""
  const whereClauseParameters = [];

  var idx = 0;

  // if (filter.provinceId > 0 && idx === 0) {
  //   whereClause = `provinceId=@${idx}`
  //   whereClauseParameters.push(filter.provinceId)
  //   idx++;
  // }
  // else if (filter.provinceId > 0 && idx > 0) {
  //   whereClause = whereClause + ` and provinceId=@${idx}`
  //   whereClauseParameters.push(filter.provinceId)
  //   idx++;
  // }

  // if (filter.auditPlaceId > 0 && idx === 0) {
  //   whereClause = `auditPlaceId=@${idx}`
  //   whereClauseParameters.push(filter.auditPlaceId)
  //   idx++;
  // }
  // else if (filter.auditPlaceId > 0 && idx > 0) {
  //   whereClause = whereClause + ` and auditPlaceId=@${idx}`
  //   whereClauseParameters.push(filter.auditPlaceId)
  //   idx++;
  // }

  if (filter.auditPeriodId > 0 && idx === 0) {
    whereClause = `auditPeriodId=@${idx}`
    whereClauseParameters.push(filter.auditPeriodId)
    idx++;
  }
  else if (filter.auditPeriodId > 0 && idx > 0) {
    whereClause = whereClause + ` and auditPeriodId=@${idx}`
    whereClauseParameters.push(filter.auditPeriodId)
    idx++;
  }

  if (filter.auditFormTypeId > 0 && idx === 0) {
    whereClause = `auditFormTypeId=@${idx}`
    whereClauseParameters.push(filter.auditFormTypeId)
    idx++;
  }
  else if (filter.auditFormTypeId > 0 && idx > 0) {
    whereClause = whereClause + ` and auditFormTypeId=@${idx}`
    whereClauseParameters.push(filter.auditFormTypeId)
    idx++;
  }

  if (filter.questionId > 0 && idx === 0) {
    whereClause = `questionId=@${idx}`
    whereClauseParameters.push(filter.questionId)
    idx++;
  }
  else if (filter.questionId > 0 && idx > 0) {
    whereClause = whereClause + ` and questionId=@${idx}`
    whereClauseParameters.push(filter.questionId)
    idx++;
  }

  if (filter.answerOfQuestionId > 0 && idx === 0) {
    whereClause = `answerOfQuestionId=@${idx}`
    whereClauseParameters.push(filter.answerOfQuestionId)
    idx++;
  }
  else if (filter.answerOfQuestionId > 0 && idx > 0) {
    whereClause = whereClause + ` and answerOfQuestionId=@${idx}`
    whereClauseParameters.push(filter.answerOfQuestionId)
    idx++;
  }


  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};


// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  // title: Yup.string()
  //   .required("پر کردن فیلد الزامی است"),
  // auditPeriodId: Yup.number()
  //   .required("auditPeriodId is required"),
  // psp: Yup.number()
  //   .min(6, "6 is minimum")
  //   .max(18, "18 is maximum"),

});

